import { render, staticRenderFns } from "./PPcSearchKit.vue?vue&type=template&id=91741da2&scoped=true&"
import script from "./PPcSearchKit.vue?vue&type=script&lang=ts&"
export * from "./PPcSearchKit.vue?vue&type=script&lang=ts&"
import style0 from "./PPcSearchKit.vue?vue&type=style&index=0&id=91741da2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91741da2",
  null
  
)

export default component.exports